module.exports = __webpack_public_path__ + "static/media/publish-simultaneous-tabletPro-es.f4495e3e.webp";